import { useTranslation } from 'react-i18next';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryBrowser from './components/CategoryBrowser';
import { Features, GuidesSection, ArticleTeaser, FaqSection, FinalCta } from './components/HomeSections';
import { useJsonLd } from '@/hooks/useJsonLd';

export default function Home() {
  const { t } = useTranslation();

  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'USFANSLINK',
    url: `${import.meta.env.VITE_SITE_URL}/`,
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [1, 2, 3, 4].map((n) => ({
      '@type': 'Question',
      name: t(`faq.q${n}`),
      acceptedAnswer: {
        '@type': 'Answer',
        text: t(`faq.a${n}`),
      },
    })),
  };

  useJsonLd({ '@graph': [websiteJsonLd, faqJsonLd] });

  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <CategoryBrowser />
        <Features />
        <ArticleTeaser />
        <GuidesSection />
        <FaqSection />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}